<template>
  <HostCards v-model="$attrs.value" :container="entity" header="" ref="component" @input="onInput" />
</template>

<script>
  import FormField from '@/mixins/FormField'
  import HostCards from '@/components/cards/Hosts'

  export default {
    name: 'FormContainerHosts',
    mixins: [
      FormField,
    ],
    components: {
      HostCards,
    },
  }
</script>
